import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useJob from '../../../hooks/useJob';
import Page from '../../../components/Page/Page';

import useEnvironment from '../../../hooks/useEnvironment';
import ActionsContainer from '../../../components/ActionsContainer/ActionsContainer';
import EnvironmentMenu from '../../../components/EnvironmentMenu/EnvironmentMenu';
import TimeFrameMenu from '../../../components/TimeFrameMenu/TimeFrameMenu';
import ThemeButton from '../../../components/ThemeButton/ThemeButton';
import JobOverview from './JobOverview';
import JobEndpointsTable from './JobEndpointsTable';
import { BreadcrumbItem } from '@hud/web-components/Breadcrumbs/Breadcrumbs';

const BASE_BREADCRUMBS = [{ title: 'PRs', to: '/explore/prs', back: 1 }];

export default function JobPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const { environment } = useEnvironment();

  const jobQuery = useJob(jobId, {
    environmentName: environment?.name,
  });

  const referralBreadcrumbs = useMemo(() => {
    return [
      {
        title: 'PRs',
        to: `/explore/prs/${jobId}`,
        nowrap: true,
      },
    ] as BreadcrumbItem[];
  }, [jobId]);

  if (jobQuery.isError) {
    return (
      <Page
        header={BASE_BREADCRUMBS}
        actions={
          <ActionsContainer>
            <EnvironmentMenu />
            <TimeFrameMenu />
            <ThemeButton />
          </ActionsContainer>
        }
      >
        {jobQuery.error.response?.status === 404
          ? jobQuery.error.response?.data.message
          : 'Something went wrong'}
      </Page>
    );
  }

  return (
    <Page
      header={
        jobQuery.isLoading
          ? 'loading'
          : [
              ...BASE_BREADCRUMBS,
              ...(jobQuery.isSuccess ? [{ title: jobQuery.data.job.id }] : []),
            ]
      }
      actions={
        <ActionsContainer>
          <EnvironmentMenu />
          <TimeFrameMenu />
          <ThemeButton />
        </ActionsContainer>
      }
    >
      <JobOverview job={jobQuery.data?.job} loading={jobQuery.isLoading} />
      <JobEndpointsTable
        job={jobQuery.data?.job}
        loading={jobQuery.isLoading}
        endpoints={jobQuery.data?.endpoints ?? []}
        referralBreadcrumbs={referralBreadcrumbs}
      />
    </Page>
  );
}
